import React from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import SiteProvider from './src/context/SiteContext';

export const wrapPageElement = ({ element }) => {
  return (
    <ClerkProvider
      publishableKey={process.env.GATSBY_CLERK_PUBLISHABLE_KEY}
      afterSignOutUrl="/account/"
    >
      <SiteProvider>{element}</SiteProvider>
    </ClerkProvider>
  );
};
